import config from "../config";
import browserHistory from "../helpers/browserHistory";
import { getActions, getType, getTypes, OBJECT_SAVE } from "../helpers/crudActions";
import HttpClient from "../helpers/httpclient";
import { getUser } from "./auth";

const SERVICE_TEAM_WRITE_FIELDS = Object.freeze([
  "service_team",
  "company_id",
  "name",
  "primary_advisor_user_id",
  "portal_view",
  "default_template",
  "service_team_setup",
  "report_posting",
  "schwab_master",
  "min_trade_size_ntf",
  "min_trade_size_tf_equities",
  "journal_adjustment_amount",
  "journal_adjustment_note",
]);

export function serviceTeamWriteBody(object) {
  const body = {};
  for (const field of SERVICE_TEAM_WRITE_FIELDS) {
    if (Object.hasOwn(object, field) && object[field] !== undefined) body[field] = object[field];
  }
  return body;
}

function getServiceTeamEditPath(serviceTeam) {
  return `/service-teams/${serviceTeam}/edit`;
}

export function redirectToServiceTeamEdit(serviceTeam) {
  browserHistory.push(getServiceTeamEditPath(serviceTeam));
}

export const USER_SERVICE_TEAMS_FETCHING = "USER_SERVICE_TEAMS_FETCHING";
export const USER_SERVICE_TEAMS_FETCHED = "USER_SERVICE_TEAMS_FETCHED";
export const USER_SERVICE_TEAMS_FETCH_FAILED = "USER_SERVICE_TEAMS_FETCH_FAILED";

function getServiceTeams(id, all, q) {
  const targetId = id ?? getUser()?.id;
  if (!targetId) return Promise.resolve({ data: { objects: [], count: 0 } });
  const params = { params: {} };
  params.params.q = q;
  if (all) {
    params.params.all = true;
  }
  return HttpClient.get(`${config.api}/users/${targetId}/service-teams`, params);
}

export function fetchServiceTeam(id) {
  return HttpClient.get(`${config.api}/service-teams/${id}`).then((r) => r.data);
}

export function fetchServiceTeams(id) {
  return (dispatch) => {
    dispatch({ type: USER_SERVICE_TEAMS_FETCHING });

    return getServiceTeams(id)
      .then((response) => response.data)
      .then(
        (result) => dispatch({ type: USER_SERVICE_TEAMS_FETCHED, result }),
        (error) => dispatch({ type: USER_SERVICE_TEAMS_FETCH_FAILED, error }),
      );
  };
}

export function fetchServiceTeamsOptions(id, all) {
  const getOption = (s) => ({ value: s.service_team, label: `${s.name} (${s.service_team})`, object: s });
  const getOptions = (serviceTeams) => ({ options: serviceTeams.objects.map(getOption) });
  return (input) => {
    return getServiceTeams(id, all, input)
      .then((r) => r.data)
      .then(getOptions);
  };
}

function searchField(search, id, q) {
  const params = { params: {} };
  if (id) {
    params.params.id = id;
  }
  if (q) {
    params.params.q = q;
  }
  return HttpClient.get(`${config.api}/service-teams/${search}`, params);
}

const getOptions = (options, field) => ({ options: options.map((o) => ({ value: o[field], label: o[field] })) });

export function fetchDefaultTemplates(id) {
  return (input) => searchField("default-templates", id, input).then((r) => getOptions(r.data, "default_template"));
}

export function fetchPortalViews(id) {
  return (input) => searchField("portal-views", id, input).then((r) => getOptions(r.data, "portal_view"));
}

const crudActions = getActions("SERVICE_TEAMS", "service-teams");

function saveServiceTeam(object, redirect = true) {
  const creating = !object.id;
  const method = creating ? "post" : "put";
  const url = `${config.api}/service-teams/${object.id || ""}`;
  return {
    type: getType(OBJECT_SAVE, "SERVICE_TEAMS"),
    payload: HttpClient[method](url, serviceTeamWriteBody(object)).then(crudActions.shouldRedirect(redirect)),
  };
}

export default {
  ...crudActions,
  save: saveServiceTeam,
  ...getTypes("SERVICE_TEAMS"),
  getServiceTeams,
  fetchServiceTeams,
  fetchServiceTeamsOptions,
};
